import axiosInstance from './axiosInstance';

export const loginApi = (data) => axiosInstance.post('/auth/login', data);